import React, { useState } from 'react'
import SnackbarToast from '../../components/toasts/SnackbarToast';
import DeleteModal from '../../components/modals/DeleteModal';
import { Close, Delete, Edit, MoreVert } from '@material-ui/icons'
import { Dropdown } from 'react-bootstrap'
import { Modal, Button, Spinner } from 'react-bootstrap';
import UpdateEbookPage from './UpdateEbookPage';
import axios from 'axios';
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';
import { useDispatch } from 'react-redux';
const EbookPageItem = ({ item, reload, openFullscreen }) => {
    const dispatch = useDispatch()
    const [open, setOpen] = useState({
        open: false,
        message: '',
        type: ''

    });
    const [modelShow, setModelShow] = useState(false);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const deletePage = async () => {
        dispatch({type:'ERROR'})
        try {
            const data = new FormData();
            data.append('id', item.id);
            const response = await axios.post(ENDPOINT + "delete-ebook-page.php", data, SecurityHeaders)
            if (response.data.status === "success") {
                dispatch({type:'DONE_LOADING'})
                setOpen({ open: true, message: "Page deleted successfully", type: "success" });
                reload();
                setDeleteConfirmation(false);
            }
            else {
                dispatch({type:'ERROR', payload:'Error occurred while deleting'})
            }
        }
        catch (err) {
            console.error(err);

dispatch({type:'ERROR',payload:err.message})        }
    }
    return (
        <>
            <SnackbarToast open={open} handleClose={() => setOpen((pre) => ({ ...pre, open: false }))}  />

            <DeleteModal show={deleteConfirmation} HandleClose={() => setDeleteConfirmation(false)} HandleDelete={deletePage} />

            <Modal show={modelShow} onHide={() => setModelShow(false)}>
                <Modal.Body>
                    <UpdateEbookPage reload={reload} item={item} handleClose={() => setModelShow(false)} />
                </Modal.Body>
            </Modal>

            <div className="col-lg-12 book-images bg-transparent mb-2">
                <div className='me-4 position-relative'>
                    <Dropdown className="options-dropdown position-absolute end-0" style={{ top: 15, right: 0 }}>
                        <Dropdown.Toggle className="bg-white options p-0 w-fit h-fit border-0">
                            <MoreVert className="text-dark" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>

                            <Dropdown.Item onClick={() => setModelShow(true)}   >
                                <Edit /> Update
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setDeleteConfirmation(true)} className='text-danger'   >
                                <Delete /> Delete
                            </Dropdown.Item>

                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <img
                    className="col-12 mb-md-2 mb-1 w-100 border border-1 border-secondary rounded-0 rounded-md-1"
                    src={item.image_url}
                    alt={`Page ${item.page_no}`}
                    loading="lazy"
                    onClick={() => openFullscreen(item.image_url)}
                />
            </div>
        </>
    )
}

export default EbookPageItem

